<template>
  <div class="context-menu-container">
    <div class="context-menu-container__header">
      <slot name="header" />
    </div>
    <div class="context-menu-container__content">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.context-menu-container {
  --menu-content-row-gap: var(--sp-ref-scale-16);
  box-sizing: border-box;
  display: grid;
  grid-template-rows: auto 1fr;
  overflow: hidden;
  max-height: calc(100vh - var(--sp-ref-scale-64));
  width: 100%;
}

.context-menu-container__content {
  overflow-y: auto;
  padding: var(--sp-ref-scale-16);
  display: flex;
  flex-direction: column;
}
</style>
